module.exports = __webpack_public_path__ + "img/white.3fd1ff5f.png";